export default __webpack_public_path__ + "static/media/South_Earth_final.66bd10ad.mp3";